import { useContext } from 'react'

import { PostTagsContext } from '../providers/PostTagsProvider'

export const usePostTagsContext = () => {
  const postTagsContext = useContext(PostTagsContext)

  if (postTagsContext === undefined) {
    throw new Error('postTagsContext must be used within a PostTagsProvider')
  }

  return postTagsContext
}
